<template>
  <div class="main">
    <Header
      :show="true"
      title="自助过磅"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <van-notice-bar
        left-icon="info-o"
        color="#ed6a0c"
        background="#FFFBE8"
        text="自助过磅需要提取您的个人信息，请您放心我们将严格保护"
      />

      <van-form
        ref="order"
        @submit="submit"
      >
        <van-field
          v-model.trim="listQuery.plateNumber"
          name="车牌号"
          label="车牌号"
          placeholder="请输入货车的车牌号"
          :maxlength="10"
          required
          :rules="[
            { required: true, message: '请输入车牌号' },
            { validator: validPlateNumber, message: '车牌号格式错误' },
          ]"
        />
        <van-field
          v-model.trim="listQuery.supplier"
          :disabled="listQuery.lockSupplier"
          name="供应商"
          label="供应商"
          placeholder="请输入供应商"
          :maxlength="30"
        />
        <van-field
          v-model.trim="listQuery.driver"
          name="司机"
          label="司机"
          placeholder="请输入您的姓名"
          :maxlength="20"
        />
        <van-field
          readonly
          clickable
          name="picker"
          :value="listQuery.materialName"
          label="货名"
          placeholder="点击选择货名"
          required
          :rules="[{ required: true, message: '请选择货名' }]"
          @click="material.show = true"
        />
        <van-popup
          v-model="material.show"
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="material.supplierMaterial"
            @confirm="handleMaterialSelect"
            @cancel="material.show = false"
          />
        </van-popup>
        <van-field
          v-model.trim="listQuery.grossWeight"
          disabled
          name="毛重"
          label="毛重"
          :maxlength="30"
        />
        <van-field
          :value="listQuery.grossTime | formatTime"
          disabled
          name="毛重时间"
          label="毛重时间"
          :maxlength="30"
        />
        <van-field
          v-if="$route.params.type == 2"
          :value="listQuery.tareWeight"
          disabled
          name="皮重"
          label="皮重"
          :maxlength="30"
        />
        <van-field
          v-if="$route.params.type == 2"
          :value="listQuery.tareTime | formatTime"
          disabled
          name="皮重时间"
          label="皮重时间"
          :maxlength="30"
        />
        <van-field
          v-if="$route.params.type == 2"
          :value="listQuery.netWeight"
          disabled
          name="实重"
          label="实重"
          :maxlength="30"
        />

        <div style="margin: 16px">
          <van-button
            round
            block
            type="info"
            :disabled="waiting"
            @click="handleConfirm"
          >
            确定
          </van-button>
        </div>
      </van-form>
    </div>

    <Footer
      :show="false"
      value="dashboard"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "@/views/components/header/index.vue";
import { showPhoneAlarm } from "@/global/function.js";
import { isPlateNumber, isNickName } from "@/utils/validate";
import { getLastWeight, autoByWeight } from "@/api/order.js";
import { getList as getMaterialList } from "@/api/material.js";
import { getList as getSupplierList } from "@/api/supplier.js";

import dayjs from "dayjs";

export default {
  name: "DashboardOrderCar",
  filters: {
    formatTime(date) {
      if (!date) return date;
      return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  components: {
    Header,
  },
  props: {},
  data() {
    return {
      loading: false,
      waiting: false,
      listQuery: {
        lockSupplier: false,
        plateNumber: "",
        supplier: "",
        driver: "",
        materialName: "",
        materialType: undefined,
        grossWeight: "",
        grossTime: "",
        tareWeight: "",
        tareTime: "",
        netWeight: "",
      },

      material: {
        show: false,
        supplierMaterial: [],
        materialList: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      name: "user/name",
    }),
  },
  created() {
    const name = this.name;
    if (name !== "" && name !== null) {
      this.listQuery.supplier = name;
      this.listQuery.lockSupplier = true;
    }
    this.getLastWeightInfo();
    this.handleGetSupplierList();
    this.handleGetMaterialList();
  },
  methods: {
    handleClickLeft() {
      // this.$router.go(-1)
      this.$router.push({ path: "/dashboard/order", query: {} });
    },
    handleClickRight() {},
    async getLastWeightInfo() {
      console.log("route", this.$route);
      const { data: result } = await getLastWeight(this.$route.params.type);
      if (!result.data) {
        console.error("未查询到数据，请联系管理人员");
        return;
      }
      const weightData = result.data;

      this.listQuery.plateNumber = weightData.plateNumber;
      this.listQuery.driver = weightData.driver;
      this.listQuery.materialName = weightData.materialName;
      this.listQuery.materialType = weightData.materialType;
      this.listQuery.grossWeight = weightData.grossWeight;
      this.listQuery.grossTime = weightData.grossTime;
      this.listQuery.tareWeight = weightData.tareWeight;
      this.listQuery.tareTime = weightData.tareTime;
      this.listQuery.netWeight = weightData.netWeight;
    },
    async handleGetMaterialList() {
      const data = {
        page: 1,
        limit: 10000,
      };

      const { data: resdata } = await getMaterialList(data);
      if (
        !!resdata.data &&
        Array.isArray(resdata.data.items) &&
        resdata.data.items.length > 0
      ) {
        this.material.materialList = resdata.data.items;
      }
    },
    handleMaterialSelect(value) {
      console.log("value", value);
      const selectMaterial = this.material.materialList.find(
        (item) => item.name === value
      );
      if (!selectMaterial) {
        this.$toast.fail("未查询到对应的物料信息，请联系管理人员");
        return;
      }

      this.listQuery.materialType = selectMaterial.materialType;
      this.listQuery.materialName = value;
      this.material.show = false;
    },
    validPlateNumber(value) {
      return new Promise((resolve) => {
        const result = isPlateNumber(value, 2, 20);
        if (result === true) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
    validNickName(value) {
      return new Promise((resolve) => {
        const result = isNickName(value, 2, 20);
        if (result === true) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
    async handleGetSupplierList() {
      const data = {
        page: 1,
        limit: 10,
        name: this.name,
      };
      const { data: resdata } = await getSupplierList(data);
      if (
        !!resdata.data &&
        Array.isArray(resdata.data.items) &&
        resdata.data.items.length > 0
      ) {
        const [supplier] = resdata.data.items;
        this.material.supplierMaterial = supplier.materialName;
      }
    },
    handleConfirm() {
      this.$refs.order.submit();
    },
    async submit() {
      const payload = {
        plateNumber: this.listQuery.plateNumber,
        supplier: this.listQuery.supplier,
        driver: this.listQuery.driver,
        materialName: this.listQuery.materialName,
        materialType: this.listQuery.materialType,
      };

      this.waiting = true;
      const result = await autoByWeight(
        this.$route.params.type,
        payload
      ).finally(() => {
        this.waiting = false;
      });

      const { data } = result;
      if (
        showPhoneAlarm(
          true,
          "toast",
          null,
          2000,
          data.code,
          "自助过磅",
          data.msg
        )
      ) {
        this.$router.push({ path: "/dashboard/order", query: {} });
      }
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
::v-deep .van-field__label {
  width: 5em;
}
::v-deep .van-checkbox {
  padding: 3px 0;
}
::v-deep .van-checkbox__icon {
  font-size: 4.5vw;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
